import React from "react";
import moment from "moment";

const SelectSlot = ({
  selected,
  setSlot,
  item,
  people,
}: {
  selected: boolean;
  setSlot: React.Dispatch<React.SetStateAction<string | undefined>>;
  item: string;
  people: number;
}) => {
  const handleTokenClick = () => {
    if (item !== undefined && typeof item === "string") {
      console.log(item);
      setSlot((prevToken) => {
        // Assuming 'people' is still relevant and determines whether to set or reset the token
        if (prevToken === undefined) {
          return item; // Set the new token if there was no previous token
        } else {
          // Compare the new token with the previous one; this logic may change depending on your requirements
          return prevToken === item ? undefined : item; // Toggle the token or update it
        }
      });

      // For debugging
      // console.log(`Token updated to: ${item}`);
    }
  };

  const start = moment(item.split(" - ")[0], "HH:mm:ss").format("hh:mmA");
  const end = moment(item.split(" - ")[1], "HH:mm:ss").format("hh:mmA");
  // Always a range, including for HIMS-sourced slots. Those systems send a start
  // time only, so the end is our inference from the gap between their slots — but
  // that same inferred end is what goes into booking.booked_slot_end anyway, and
  // only the START is ever sent on to the vendor. Hiding it wouldn't make us less
  // approximate, it would just make this screen disagree with the Selected chip
  // and with WhatsApp, which both show the range.
  const label = `${start} - ${end}`;

  if (selected) {
    return (
      <button
        className="px-4 py-3 rounded-lg border-2 border-[#E5E5E5] flex justify-center items-center cursor-pointer bg-[#0F3CBE] text-white whitespace-nowrap min-w-[170px]"
        type="button"
      >
        <p>{label}</p>
      </button>
    );
  }

  return (
    <button
      className="px-4 py-3 rounded-lg border-2 border-[#E5E5E5] flex justify-center items-center cursor-pointer hover:bg-[#0F3CBE] hover:text-white whitespace-nowrap min-w-[170px]"
      type="button"
      onClick={handleTokenClick}
    >
      <p>{label}</p>
    </button>
  );
};

export default SelectSlot;
